import(/* webpackMode: "eager" */ "/workspace/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/workspace/src/components/providers.tsx");
